import { combineReducers } from "redux";
const UPDATE_LOGIN_STATUS = "UPDATE_LOGIN_STATUS";
const SET_LOGIN_DETAILS = "SET_LOGIN_DETAILS";

export function updateLoginStatus(userData) {
  return {
    type: UPDATE_LOGIN_STATUS,
    userData,
  };
}

// Maps the raw /api/login response onto the store shape.
// `name` -> `userName` (existing consumers), `division` -> `divId` (existing consumers),
// and the login-time `projectId` array -> `projectIdList` so it never overwrites the
// single selected `projectId` that the rest of the app reads from the store.
// `extra` is merged last for caller-supplied fields such as `Pagename`.
export function setLoginDetails(data = {}, extra = {}) {
  const { name, projectId, ...rest } = data;

  return {
    type: SET_LOGIN_DETAILS,
    userData: {
      ...rest,
      ...extra,
      isLoggedIn: true,
      userName: name,
      divId: data.division,
      projectIdList: Array.isArray(projectId) ? projectId : [],
    },
  };
}

const defaultUserData = {
  isLoggedIn: false,
  userName: "",
  userId: "",
  username: "",
  role: "",
  token: "",
  Pagename: "Dashboard",
  projectId: "",
  projectIdList: [],
  clientId: "",
  profileImage: "",
  projectType: "",
  divId: "",
  division: 0,
  divisionName: "",
  subDivision: 0,
  subDivisionName: "",
  circle: 0,
  circleName: "",
  wing: 0,
  wingName: "",
  area: 0,
  areaName: "",
  stateId: 0,
  stateName: "",
  firstTimeLoggedIn: 0,
  isTemporaryPasswordChanged: 0,
  isTemporaryEnggPasswordChanged: 0,
  defaultMainMenu: [],
  projectSearchParams: [],
};

function readSavedState() {
  const savedState = sessionStorage.getItem("reduxState");
  if (!savedState) return defaultUserData;

  try {
    return { ...defaultUserData, ...JSON.parse(savedState) };
  } catch (error) {
    sessionStorage.removeItem("reduxState");
    return defaultUserData;
  }
}

const initialState = readSavedState();

function userDetails(state = initialState, action) {
  switch (action.type) {
    case UPDATE_LOGIN_STATUS:
    case SET_LOGIN_DETAILS: {
      const updatedState = {
        ...state,
        ...action.userData,
      };

      sessionStorage.setItem("reduxState", JSON.stringify(updatedState));

      return updatedState;
    }

    default:
      return state;
  }
}

const userDataStore = combineReducers({
  userDetails,
});

export default userDataStore;
